import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\app\\kyriad-hotels\\KyriadBrandPage.js");
